import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { noop } from 'ts-essentials';
import '../device-settings/settings-content.css';
import '../device-settings/small-dialog.sass';
import { List, Map } from 'immutable';
import './cool-settings-dialog.sass';
import { unpack_validation, } from 'webui/Z3KConfigParser/validation/types';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { List as MaterialList, ListItem, ListItemText } from '@mui/material';
import { check_null_values } from 'webui/Z3KConfigParser/validation/collections';
import { MessageBox } from 'shared/components/dialogs/message-box';
function default_state_subset(all_tabs_state, key) {
    return all_tabs_state[key];
}
function refine_errors(obj) {
    const res = [];
    const tmp = [obj];
    while (tmp.length > 0) {
        const el = tmp[0];
        tmp.splice(0, 1);
        if (typeof el === 'string')
            res.push(el);
        if (Array.isArray(el))
            tmp.push(...el);
        else if (el && el.constructor === Object)
            tmp.push(...Object.values(el));
        else if (Map.isMap(el))
            tmp.push(...el.values());
        //@ts-ignore
        else if (List.isList(el))
            tmp.push(...el);
    }
    return res;
}
function isEmpty(obj) {
    return refine_errors(obj).length == 0;
}
export var DialogSaveType;
(function (DialogSaveType) {
    DialogSaveType["Save"] = "Save";
    DialogSaveType["Apply"] = "Apply";
})(DialogSaveType || (DialogSaveType = {}));
export class CoolSettingsDialog extends React.PureComponent {
    constructor(props) {
        super(props);
        const ui_state = this.props.open ? this.get_ui_state(this.props) : null;
        this.state = {
            ui_state,
            validation: ui_state != null ? this.validate(ui_state) : null,
            selected_tab_key: null,
            errors_shown: false,
            errors: null,
            dirty: false,
            // select_tab: props.select_tab,
        };
    }
    componentDidUpdate(prevProps) {
        if ((!prevProps.open && this.props.open) ||
            prevProps.force_update_key != this.props.force_update_key) {
            const ui_state = this.get_ui_state(this.props);
            this.setState({
                ui_state,
                validation: this.validate(ui_state),
                selected_tab_key: null,
                dirty: false,
                // select_tab: this.props.select_tab,
            });
            //     // if (this.props.select_tab) {
            //     //     this.props.select_tab(null);
            //     // }
            // } else if (prevProps.open && this.props.open) {
            //     this.setState({
            //         selected_tab_key: this.props.selected_tab ?? null,
            //         select_tab: this.props.select_tab,
            //     });
        }
    }
    static active_tabs(data, volatile_data, tabs, tabs_enabled_by_default) {
        return tabs.filter((tab) => tab.isEnabled?.(data) ?? tabs_enabled_by_default ?? true);
    }
    shown_tabs(props, ui_state) {
        const effective_ui_state = ui_state ?? this.state.ui_state;
        if (effective_ui_state == null)
            return [];
        return CoolSettingsDialog.active_tabs(props.data, props.volatile_data, props.tabs, props.tabs_enabled_by_default).filter((tab) => {
            const shown = tab.isShown?.((tab.state_subset ?? default_state_subset)(effective_ui_state, tab.key), props.volatile_data);
            if (shown != null)
                return shown;
            return true;
        });
    }
    static has_any_active_tab(data, volatile_data, tabs, tabs_enabled_by_default) {
        return (this.active_tabs(data, volatile_data, tabs, tabs_enabled_by_default).length > 0);
    }
    get_ui_state(props) {
        const ui_state = {};
        for (const tab of CoolSettingsDialog.active_tabs(props.data, props.volatile_data, props.tabs, props.tabs_enabled_by_default))
            ui_state[tab.key] = tab.data2state?.(props.data);
        return ui_state;
    }
    update_ui_state = (key, setter) => {
        this.setState((state) => {
            if (state.ui_state == null)
                return null;
            const existing_state = state.ui_state[key];
            const new_ui_state = {
                ...state.ui_state,
                [key]: {
                    ...(existing_state != null ? existing_state : {}),
                    ...setter,
                },
            };
            return {
                ui_state: new_ui_state,
                validation: this.validate(new_ui_state),
                dirty: true,
            };
        });
    };
    validate(ui_state) {
        let validation = {};
        for (const tab of this.shown_tabs(this.props, ui_state)) {
            const tab_state = (tab.state_subset ?? default_state_subset)(ui_state, tab.key);
            const err_iter = tab.validate?.(tab_state);
            validation = {
                ...validation,
                [tab.key]: isEmpty(err_iter) ? null : err_iter,
            };
        }
        return check_null_values(validation);
    }
    on_try_save = (saveType) => {
        if (this.state.ui_state == null)
            return false;
        let first_invalid_key = null;
        for (const tab of this.shown_tabs(this.props))
            if (!isEmpty(unpack_validation(this.state.validation, tab.key))) {
                first_invalid_key = tab.key;
                break;
            }
        if (first_invalid_key != null) {
            this.on_change_tab(first_invalid_key);
            this.setState({
                errors_shown: true,
                errors: refine_errors(this.state.validation),
            });
            return false;
        }
        const data = {};
        for (const tab of this.shown_tabs(this.props)) {
            const tab_state = (tab.state_subset ?? default_state_subset)(this.state.ui_state, tab.key);
            data[tab.key] = tab.state2data?.(tab_state, tab.key);
        }
        this.props.onSave(data, saveType);
        return true;
    };
    // on_change_tab = (key: string | null): void => {
    //     if (this.state.select_tab) {
    //         this.state.select_tab(key);
    //     } else {
    //         this.setState({selected_tab_key: key});
    //     }
    // };
    on_change_tab = (key) => this.setState({ selected_tab_key: key });
    render() {
        const ui_state = this.state.ui_state;
        if (ui_state == null)
            return null;
        const shown_tabs = this.shown_tabs(this.props);
        if (shown_tabs.length === 0)
            return null;
        return (_jsxs(ErrorBoundary, { children: [this.props.render({
                    frameClass: this.props.frameClass,
                    title: this.props.title,
                    subtitle: this.props.subtitle,
                    open: this.props.open,
                    selected_tab_key: this.state.selected_tab_key,
                    tabs: shown_tabs.map((tab) => ({
                        key: tab.key,
                        title: tab.title,
                        validation: unpack_validation(this.state.validation, tab.key),
                        state: (tab.state_subset ?? default_state_subset)(ui_state, tab.key),
                        data_tooltip: tab.data_tooltip,
                        element: tab.element,
                    })),
                    volatile_data: this.props.volatile_data,
                    save_visible: this.props.save_visible ?? true,
                    save_disabled: this.props.save_disabled ?? false,
                    additionalButtons: this.props.additionalButtons,
                    zIndex: this.props.zIndex,
                    onChangeState: this.update_ui_state,
                    onChangeTab: this.on_change_tab,
                    onTrySave: this.on_try_save,
                    onRequestClose: this.props.onRequestClose,
                    onSetServiceMode: this.props.onSetServiceMode ?? noop,
                    password: this.props.password,
                    service_mode: this.props.service_mode,
                    need_service_view: this.props.need_service_view,
                    dirty: this.state.dirty,
                }), _jsx(MessageBox, { isError: true, open: this.state.errors_shown, onClose: () => this.setState({ errors_shown: false }), title: "\u041D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438", children: _jsx(MaterialList, { component: "nav", children: (this.state.errors ?? []).map((error, i, errors) => (_jsx(ListItem, { divider: errors.length > 1, children: _jsx(ListItemText, { primary: error }) }, i))) }) })] }));
    }
}
export function render_tab(tab, volatile_data, onChangeState) {
    const El = tab.element;
    return (_jsx(El, { tab_key: tab.key, state: tab.state, volatile_data: volatile_data, validation: tab.validation, onChangeState: onChangeState }));
}
